import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 29,
	height: 29,
	viewBox: "0 0 29 29",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "a",
		fill: "currentColor",
		transform: "rotate(45 14.5 14.5)",
		d: "M15 14h8.5a.5.5 0 1 1 0 1H15v8.5a.5.5 0 1 1-1 0V15H5.5a.5.5 0 1 1 0-1H14V5.5a.5.5 0 1 1 1 0V14z"
	})
});
export default SvgClose;
